import { render, staticRenderFns } from "./AddressDivider.vue?vue&type=template&id=7966252e&functional=true&"
import script from "./AddressDivider.vue?vue&type=script&lang=js&"
export * from "./AddressDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports